module.exports = __webpack_public_path__ + "assets/img/course_worksheet_head2.850fa4e5.png";